import styled, { css } from 'styled-components';

const menuMotion = css`
  opacity: 0;
  transform: translateY(-8px) scale(0.96);
  transition: opacity 160ms ease, transform 160ms ease;
  &[data-open='true'] {
    opacity: 1;
    transform: translateY(0) scale(1);
  }
  @media (prefers-reduced-motion: reduce) {
    transition: none;
    transform: none;
  }
`;

export const StyledClubSwitcher = styled.div`
  position: relative;
  min-width: 0;
  ${({ $variant }) =>
    $variant === 'nav'
      ? css`
          width: 100%;
        `
      : css`
          @media screen and (max-width: 1199px) {
            min-width: 72px;
          }
        `}
`;

export const StyledClubTrigger = styled.button`
  display: inline-flex;
  align-items: center;
  gap: 6px;
  min-width: 0;
  max-width: min(260px, 24vw);
  @media screen and (max-width: 1199px) {
    max-width: min(200px, 42vw);
    min-width: 72px;
  }
  margin: 0;
  padding: 0;
  border: none;
  background: transparent;
  color: ${({ theme }) => theme.headerText};
  cursor: pointer;
  font-family: 'Archivo', sans-serif;
  font-size: 15px;
  font-weight: 600;
  line-height: 1.15;
  text-align: left;
  user-select: none;
  -webkit-user-select: none;
  -webkit-tap-highlight-color: transparent;
  ${({ $variant }) =>
    $variant === 'nav' &&
    css`
      width: 100%;
      max-width: none;
      justify-content: space-between;
      padding: 10px 12px;
      border-radius: 10px;
      background: ${({ theme }) => theme.headerControl};
      border: 1px solid rgba(255, 255, 255, 0.12);
      font-size: 14px;
    `}
`;

export const StyledClubTriggerName = styled.span`
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

export const StyledClubChevron = styled.span`
  display: inline-flex;
  flex-shrink: 0;
  color: ${({ theme }) => theme.headerAccent};
  transition: transform 160ms ease;
  &[data-open='true'] {
    transform: rotate(-180deg);
  }
  svg {
    display: block;
  }
  @media (prefers-reduced-motion: reduce) {
    transition: none;
  }
`;

export const StyledClubOverlay = styled.div`
  position: fixed;
  inset: 0;
  z-index: 400;
  background: transparent;
  pointer-events: ${({ $open }) => ($open ? 'auto' : 'none')};
`;

export const StyledClubMenu = styled.div`
  position: fixed;
  z-index: 401;
  box-sizing: border-box;
  min-width: 0;
  padding: 6px;
  border-radius: 14px;
  background: ${({ theme }) => theme.card};
  color: ${({ theme }) => theme.text};
  border: 1px solid ${({ theme }) => theme.border};
  box-shadow: 0 16px 40px rgba(0, 0, 0, 0.28);
  transform-origin: top right;
  ${menuMotion}
  ${({ $variant }) =>
    $variant === 'nav' &&
    css`
      transform-origin: top center;
    `}
`;

export const StyledClubMenuLabel = styled.p`
  margin: 0;
  padding: 8px 10px 6px;
  font-family: 'Archivo', sans-serif;
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  color: ${({ theme }) => theme.textFaint};
`;

export const StyledClubOption = styled.button`
  display: flex;
  align-items: center;
  gap: 10px;
  width: 100%;
  margin: 0;
  padding: 8px 10px;
  border: none;
  border-radius: 10px;
  background: ${({ $active, theme }) =>
    $active ? theme.hover : 'transparent'};
  color: ${({ theme }) => theme.text};
  cursor: pointer;
  text-align: left;
  font-family: 'Archivo', sans-serif;
  &:hover,
  &:focus-visible {
    background: ${({ theme }) => theme.hover};
    outline: none;
  }
  &[data-join='true'] {
    color: ${({ theme }) => theme.textMuted};
  }
`;

export const StyledClubCrest = styled.span`
  display: grid;
  place-items: center;
  flex-shrink: 0;
  width: 32px;
  height: 32px;
  background: transparent;
  font-family: 'Archivo', sans-serif;
  font-size: 12px;
  font-weight: 700;
  color: ${({ theme }) => theme.textMuted};
  img {
    width: 32px;
    height: 32px;
    object-fit: contain;
  }
`;

export const StyledClubOptionCopy = styled.span`
  display: flex;
  flex-direction: column;
  min-width: 0;
  flex: 1;
`;

export const StyledClubOptionName = styled.span`
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-size: 14px;
  font-weight: 600;
  line-height: 1.2;
`;

export const StyledClubOptionMeta = styled.span`
  margin-top: 2px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-size: 12px;
  font-weight: 500;
  color: ${({ theme }) => theme.textMuted};
`;

export const StyledClubCheck = styled.span`
  display: inline-flex;
  flex-shrink: 0;
  color: ${({ theme }) => theme.headerAccent};
  svg {
    display: block;
  }
`;
